import _ from 'lodash';

const FONT_SIZE_UPPER_BOUND = 51;

export const defaultFontSizeOption = {
  name: 'Auto',
  value: 0,
};

export const fontSizeOptions = [
  defaultFontSizeOption,
  ..._.range(1, FONT_SIZE_UPPER_BOUND).map(fontSizeOption => ({
    name: fontSizeOption.toString(),
    value: fontSizeOption,
  })),
];
